import React from "react";
import { IOrdersAudit } from "./types";
import { useLogin } from "../login";
import { errorCatcher, useSnackbar } from "../../hooks";
import axios from "axios";
import { environment } from "../../environment";


type GetOrderAudits = (orderId: number) => Promise<IOrdersAudit[]>;

type OrdersAuditKeyFunctions = {
    getOrderAudits: GetOrderAudits;
}

type UseOrdersAudit = [
    IOrdersAudit[],
    OrdersAuditKeyFunctions
]

export const useOrdersAudit = (): UseOrdersAudit => {
    const [ordersAudit, setOrdersAudit] = React.useState<IOrdersAudit[]>([]);

    const [, authToken, loginFunctions] = useLogin();
    const [, setSnackbar] = useSnackbar();

    const getOrderAudits = async (orderId: number): Promise<IOrdersAudit[]> => {
        const response = await axios.get(`${environment.v2Url}/orders-audit?order_id=${orderId}`, {
            headers: {
                'X-Wallmates-Auth': authToken,
                'Cache-Control': 'no-cache'
            }
        }).catch((err: any) => errorCatcher(err, loginFunctions.logout));

        if (response) {
            setOrdersAudit(response.data);
            return response.data;
        } else {
            setSnackbar({
                show: true,
                text: 'Error fetching order audits',
                snackbarLevel: 'error'
            });
            setOrdersAudit([]);
            return [];
        }
    }

    return [
        ordersAudit,
        {
            getOrderAudits
        }
    ];
}